import Label from "lib/Label";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { calculateGrandTotal, generateCurrency } from "helper/calculateNetAsset";
import { useDispatch, useSelector } from "react-redux";
import { assignValueToKey, setSelectedData } from "redux/formDisplay";
import { convertNumberToWord } from "helper/convertNumberToWord";
import { useEffect } from "react";

const Currency = (props) => {
  const {
    placeholder,
    label,
    value,
    onChange,
    events,
    name,
    disabled,
    error,
    size,
    className,
    tooltip,
    isEditable,
    is_disabled,
    selectedData,
    validators,
    currency_type,
    formErr,
    setFormErr,
    clearFieldError,
  } = props;
  const data = useSelector((state) => state?.formData?.selectedData);
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const dispatch = useDispatch();
  let currency;
  let result;
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  const onKeyUpCapture = async (item) => {
    if (events) {
      IndirectEval(events?.onKeyUpCapture);
    }
  };

  const calculateTheTotal = async (add, subtract, netField, totalField) => {
    calculateGrandTotal(add, subtract, netField, totalField, data, dispatch, assignValueToKey)
  };

  const numberToWords = async (item) => {
    result = await convertNumberToWord(value,currency_type);
    dispatch(setSelectedData({ key: item, value: result }));
    return item;
  };

  const handleChange = (e) => {
    const {name,value} = e.target;
    let pattern = /^[1-9][0-9\,]*(\.[0-9]{0,2})?$/;
    if(value === "" || pattern.test(value)){
      if(value) {
        currency = value?.split(",").join("")
      }
      currency = generateCurrency(currency,currency_type)
      onChange(name,currency)
    }
  }

  useEffect(() => {
    if(selectedData && formErr){
      let errorKeys = Object.keys(formErr);
      errorKeys.forEach((item) => {
        if(Object.keys(selectedData)?.includes(item)){
          clearFieldError(item)
        }
      })
    }
  },[selectedData])

  return (
    <div className={size}>
      {label ? (
        <Label label={label} tooltip={tooltip} validators={validators} />
      ) : null}
      <input
        type="text"
        name={name}
        className={`form-input ${errorClass} ${!isEditable && "radioDisabled"}`}
        placeholder={placeholder}
        value={value ? value : ""}
        onChange={(e) => handleChange(e)}
        onKeyUpCapture={onKeyUpCapture}
        disabled={
          selectedData &&
          is_disabled &&
          eval(is_disabled)
            ? true
            : disabled
            ? disabled
            : isEditable
            ? false
            : true
        }
      />
      {error?.length !== 0 && <ErrorMessage error={error} />}
    </div>
  );
};

export default Currency;
